import { Container, Typography } from "@mui/material";

export function Closed() {
  return (
    <Container maxWidth="md" style={{height: '100vh' }}>
      <h1>Disability Seating Requests Closed</h1>
      <Typography>At this time we are no longer processing requests for disability seating at Commencement {new Date().getFullYear()}. If you need seats in the disability section, please let Commencement staff know when you arrive at the ceremony and they'll direct you to a team member who can assist you.</Typography>
      <Typography>Frequently asked questions about accessibility at Commencement are answered at <a href="https://commencement.mit.edu/guests/accessibility">https://commencement.mit.edu/guests/accessibility</a></Typography>
    </Container>
  );
}
